export const ComponentsLoaderSymbol = Symbol('ComponentsLoader')
